import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearPopupInfo } from "./redux/topicSlice";
import "./TopicForm.css";
import {
  getAllTopicsThunk,
  getTopicByIdentifiers,
  postTopic,
  updateTopicThunk,
} from "./redux/topicReducer";
import { setStepIndex, setStepValid, stopTour } from "../../../redux/globalJoyrideSlice";
import { getSyllabusScheduleThunk } from "../redux/syllabusthunk";

const TopicForm = () => {
  const dispatch = useDispatch();
  const { popupInfo } = useSelector((state) => state.topic);
  const existingTopic = popupInfo?.existingTopic;

  const isEdit = !!existingTopic;

  const [formData, setFormData] = useState({
    topicName: "",
    details: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // useEffect(() => {
  //   if (popupInfo) {
  //     dispatch(
  //       getTopicByIdentifiers({
  //         schedule_id: popupInfo.schedule_id,
  //         chapter: popupInfo.chapter,
  //         period_number: popupInfo.period_number,
  //         subject_id: popupInfo.subject_id,
  //         class_id: popupInfo.class_id,
  //         teacher_id: popupInfo.teacher_id,
  //         section_id: popupInfo.section_id,
  //       })
  //     );
  //   }
  // }, [popupInfo, dispatch]);

  useEffect(() => {
    if (existingTopic) {
      setFormData({
        details: existingTopic.topic || "",
      });
    } else {
      setFormData({
        details: "",
      });
    }
  }, [existingTopic]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      syllabusScheduleId: popupInfo.schedule_id,
      teacherId: popupInfo.teacher_id,
      topicName: formData.details,
    };

    try {
      if (isEdit) {
        await dispatch(
          updateTopicThunk({
            id: existingTopic?.id,
            topic: formData.details,
          })
        ).unwrap();

        alert("Topic updated successfully");
      } else {
        await dispatch(postTopic(payload)).unwrap();

        alert("Topic created successfully");
      }

      // ✅ THIS IS THE MAIN FIX
      await Promise.all([
        dispatch(
          getAllTopicsThunk({
            teacher_id: popupInfo.teacher_id,
            school_id: popupInfo.school_id || 1,
          })
        ),
        dispatch(getSyllabusScheduleThunk(popupInfo.teacher_id))
      ]);

      // ✅ Close AFTER data refresh
      dispatch(clearPopupInfo());

    } catch (error) {
      console.error("Submit failed:", error);
    }
  };

  return (
    <div className="topic-container">
      <h2 className="topic-header">
        {isEdit ? "Edit Topic Details" : "Add Topic Details"}
      </h2>
      <form onSubmit={handleSubmit} className="topic-form">
        {/* <div className="topic-form-group">
          <label className="topic-label">Topic Name:</label>
          <input
            type="text"
            name="topicName"
            value={formData.topicName}
            onChange={handleChange}
            className="topic-input"
            placeholder="Enter topic name"
          />
        </div> */}

        <div className="topic-form-group">
          <label className="topic-label">Details:</label>
          <textarea
            rows="5"
            name="details"
            value={formData.details}
            onChange={(e) => {
              handleChange(e)
              dispatch(setStepValid(true))
            }}
            className="topic-textarea"
            placeholder="Enter topic details"
            data-tour="topic-details-step"
          />
        </div>

        <div className="topic-button-group">
          <button type="submit" className="topic-save-button"
            data-tour="topic-save-step"

          >
            {isEdit ? "Update" : "Save"}
          </button>
          <button
            type="button"
            onClick={() => dispatch(clearPopupInfo())}
            className="topic-cancel-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default TopicForm;
